import { PRINT_RATIO_COUNT } from '@/types';

export const ZOOM_CONFIG = {
  MIN: 1,
  MAX: 3,
  STEP: 0.1,
  DEFAULT: 1,
} as const;

export const CROPPER_DIMENSIONS = {
  HEIGHT: 600,
  HEIGHT_CLASS: 'h-[600px]',
} as const;

export const REQUIRED_CROP_COUNT = PRINT_RATIO_COUNT;

export const VALIDATION_MESSAGES = {
  INCOMPLETE_CROPS: `Please complete all ${REQUIRED_CROP_COUNT} crop ratios`,
  INCOMPLETE_CROPS_UPLOAD: `Please complete all ${REQUIRED_CROP_COUNT} crop ratios before testing upload`,
  UPLOAD_FAILED: 'Upload failed',
  UPLOAD_SUCCESS: 'Upload successful!',
} as const;

export const STATUS_MESSAGES = {
  GENERATING_BLOBS: 'Generating image blobs...',
  GENERATED_FILES: `Generated ${REQUIRED_CROP_COUNT} image files`,
  UPLOADING: 'Uploading to Bunny CDN and Google Drive...',
  UPLOAD_COMPLETE: 'Upload complete!',
} as const;

// Orientation Options
export const ORIENTATION_OPTIONS = {
  PORTRAIT: 'portrait',
  LANDSCAPE: 'landscape',
} as const;

export type OrientationType = typeof ORIENTATION_OPTIONS[keyof typeof ORIENTATION_OPTIONS];

